.CollapsedButton
    position: fixed
    width: 60px
    height: 60px
    border-radius: $globalCartButtonShape
    background-color: rgb($globalCartColorsButtonBackgroundPrimary)
    display: flex
    justify-content: center
    align-items: center
    border: 0
    cursor: pointer
    appearance: none
    font-size: 12px
    z-index: $indexCartButton
    background-position: center
    stroke: rgb($globalCartColorsButtonIcon)
    fill: rgb($globalCartColorsButtonIcon)
    transition: background 0.5s
    box-shadow: $globalCartButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalCartButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    .ItemsNumberContainer
        position: absolute
        right: 0
        top: 0
        width: 20px
        height: 20px
        border-radius: $globalCartButtonShape
        background: rgb($globalCartColorsAmountBackgroundPrimary)
        color: rgb($globalCartColorsAmountFont)
        display: flex
        justify-content: center
        align-items: center
    &:hover
        background: rgb($globalCartColorsButtonBackgroundSecondary) radial-gradient(circle, transparent 1%, rgb($globalCartColorsButtonBackgroundTertiary) 1%) center/15000%
        .ItemsNumberContainer
            background: rgb($globalCartColorsAmountBackgroundSecondary)
    &:active
        background-size: 100%
        transition: background 0s
        background-color: rgb($globalCartColorsButtonBackgroundPrimary)
        .ItemsNumberContainer
            background: rgb($globalCartColorsAmountBackgroundPrimary)
    &:focus
        outline: none

.Animated
    animation-name: cartButtonAnimation
    animation-duration: 1s

.Loading
    animation-name: cartButtonAnimation
    animation-duration: 2s
    animation-iteration-count: infinite

.RippleContainer
    position: absolute
    width: 100%
    height: 100%
    background: rgb($globalSettingsBackgroundPrimary)
    border-radius: 50%
    transform: scale(.01)
    opacity: 0.4
    pointer-events: none

.Rippled
    animation-name: rippleAnimation
    animation-duration: 1s

@keyframes cartButtonAnimation
    0%
        transform: scale(1)
    25%
        transform: scale(1.2)
    50%
        transform: scale(1)
    75%
        transform: scale(1.2)
    100%
        transform: scale(1)

@keyframes rippleAnimation
    0%
        opacity: 0.5
        transform: scale(.01)
    50%
        opacity: 0.1
        transform: scale(1)
    51%
        opacity: 0.5
        transform: scale(.01)
    99%
        opacity: 0.1
        transform: scale(1)
    100%
        opacity: 0
        transform: scale(.01)
